import { Box, Typography, useTheme } from "@mui/material";
import { delftBlue, flame } from "@/theme/colors";

const CategoryBadge = ({ category = "activity" }) => {
  const theme = useTheme();
  const isActivity = category === "activity" || category === "Activity";

  return (
    <Box
      sx={{
        paddingLeft: { xs: 0.75, sm: 1 },
        paddingRight: { xs: 0.75, sm: 1 },
        paddingTop: { xs: 0.4, sm: 0.5 },
        paddingBottom: { xs: 0.4, sm: 0.5 },
        background: isActivity ? delftBlue[50] : flame[50],
        borderRadius: 2,
        outline: `1px ${isActivity ? delftBlue[300] : flame[300]} solid`,
        outlineOffset: "-1px",
        display: "inline-flex",
        justifyContent: "flex-start",
        alignItems: "center",
      }}
    >
      <Typography
        sx={{
          color: isActivity ? theme.palette.neutral[700] : theme.palette.neutral[600],
          fontSize: { xs: 10, sm: 11 },
          fontFamily: "Montserrat, sans-serif",
          fontWeight: 500,
          lineHeight: 1.45,
          whiteSpace: "nowrap",
        }}
      >
        {isActivity ? "Activity" : "Others"}
      </Typography>
    </Box>
  );
};

export default CategoryBadge;



